import Vue from 'vue';
import moment from "moment";



Vue.mixin({

    methods: {

        formatPrice(v) {

            return 'R$ ' + (+v)
                .toFixed(2)
                .replace('.', ',')
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        },
        notify(text, type = 'success') {
            setTimeout(() => this.$root.$emit('notify', {text, type}), 100);
        },
        formatDate(value) {
            return moment(value).format("DD/MM/YYYY")
        },
        async getUserDates(user) {
            const userd = await this.$http.get(`/user/get-one?id=${user.id}`)
            return userd
        }
    },
});
